import { User } from '@/models/User';
import { Route } from 'vue-router';
import Token from '@/support/Token';
import store from '@/store';
import router from '..';

// eslint-disable-next-line
export default async (to: Route, from?: Route, next?: any) => {
  let user: User|null = store.getters.user;

  if (to.meta?.auth === false) {
    return next();
  }

  if (Token.get('access') && ! store.getters.user) {
    await (new User()).current().then((currentUser) => {
      user = currentUser;
      store.dispatch('userAuthenticated', user);
    }).catch(() => {
      Token.delete('access');
      store.dispatch('userDeauthenticated');
    });
  }

  if (! user) {
    return next({
      path: '/',
      query: {
        redirect: to.fullPath,
      },
    });
  }

  if (user.force_password_change) {
    return next({
      path: '/wachtwoord-instellen',
    });
  }

  // TODO: check if ur on local or staging
  if (! user.mfa_token) {
    return next({
      path: '/mfa-instellen',
    });
  }
};
